module.exports = __webpack_public_path__ + "img/edit.65be106e.svg";